function install(app) {}

export default {
  install,
};
